(() => {
  if (window.__thistlecartProductControlsLoaded) return;
  window.__thistlecartProductControlsLoaded = true;

  const rootUrl = () => window.Shopify?.routes?.root || '/';

  async function handleBuyNow(button) {
    if (button.disabled || button.classList.contains('loading')) return;

    const productFormElement = button.closest('product-form');
    const form = productFormElement?.querySelector('form[data-type="add-to-cart-form"]');
    const nativeSubmit = productFormElement?.querySelector('[name="add"]');
    if (!form || nativeSubmit?.disabled || nativeSubmit?.getAttribute('aria-disabled') === 'true') return;

    const spinner = button.querySelector('.loading__spinner');
    button.disabled = true;
    button.classList.add('loading');
    spinner?.classList.remove('hidden');

    try {
      const response = await fetch(window.routes?.cart_add_url || `${rootUrl()}cart/add.js`, {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
        body: new FormData(form),
      });
      const payload = await response.json();
      if (!response.ok || payload?.status) {
        throw new Error(payload?.description || payload?.message || 'Unable to start checkout.');
      }
      window.location.assign(`${rootUrl()}checkout`);
    } catch (error) {
      productFormElement?.handleErrorMessage?.(error.message || 'Unable to start checkout.');
      button.disabled = false;
      button.classList.remove('loading');
      spinner?.classList.add('hidden');
    }
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest('.tc-buy-now-button');
    if (!button) return;
    event.preventDefault();
    handleBuyNow(button);
  });

  if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS?.optionValueSelectionChange) {
    subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, ({ data }) => {
      data?.event?.target?.closest?.('product-info')
        ?.querySelectorAll('.tc-buy-now-button')
        .forEach((button) => { button.disabled = true; });
    });
  }

  if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS?.variantChange) {
    subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
      document.querySelector(`#MainProduct-${CSS.escape(String(data?.sectionId))}`)
        ?.querySelectorAll('.tc-buy-now-button')
        .forEach((button) => { button.disabled = !data?.variant?.available; });
    });
  }
})();
